import React, { useState } from 'react';
import logo from "../assets/Logo/WoaomLogo.png";
import { Menu, X } from 'lucide-react';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  return (
    <nav className="font-inter mx-auto h-auto w-full max-w-screen-2xl md:relative md:top-0">
      <div className="flex flex-col md:flex-row items-center justify-between px-6 py-6 md:px-10 md:py-4 xl:px-20 relative">

        {/* Logo on the Left */}
        <div className="flex-shrink-0">
          <a href="/">
            <img
              src={logo}
              alt="Woaom Web Design Logo"
              width="180"
              height="auto"
              className="mb-4 md:mb-0"
            />
          </a>
        </div>

        {/* Desktop Navigation and Contact Button */}
        <div className="hidden md:flex md:items-center md:space-x-8">

          {/* Navigation Links with Dropdowns */}
          <div className="flex flex-row space-x-6 font-semibold text-black uppercase">

            {/* Services Dropdown */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('services')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <a href='/services' className="cursor-default inline-block hover:text-[#c6884a] ">WORK WITH ME</a>
              {/* {openDropdown === 'services' && (
                <div className="absolute bg-white shadow-lg mt-0 py-2 z-50 w-56">
                <a href="/launchglowup" className="block px-2 py-2 hover:font-azeri">Launch Glow-Up Package</a>
                <a href="/businessglowup" className="block px-2 py-2 hover:font-azeri">The Business Glow-Up Package</a>
                <a href="/ceoglowup" className="block px-2 py-2 hover:font-azeri">The CEO Glow-Up (VIP)</a>
                <a href="/services" className="block px-2 py-2 hover:font-azeri">Other Services</a>
                  <a href="/webdesign" className="block px-2 py-2 hover:font-azeri">Website Design</a>
                  <a href="/services" className="block px-2 py-2 hover:font-azeri">All Services and Packages</a>
                </div>
              )} */}
            </div>

            {/* About Dropdown */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('about')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <a href='/clientwork' className="cursor-default inline-block hover:text-[#c6884a]">CLIENT WORK</a>
              {/* {openDropdown === 'about' && (
                <div className="absolute bg-white shadow-lg mt-0 py-2 z-50 w-48">
                 <a href="/casestudies" className="block px-2 py-2 hover:font-azeri">Case Studies</a>
                  <a href="/testimonials" className="block px-2 py-2 hover:font-azeri">Testimonials</a>
                </div>
              )} */}
            </div>

             {/* template Dropdown */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('template')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <a href='/templateshop' className="cursor-default inline-block hover:text-[#c6884a]">TEMPLATE SHOP</a>
              {/* {openDropdown === 'template' && (
                <div className="absolute bg-white shadow-lg mt-0 py-2 z-50 w-48">
                  <a href="/template" className="block px-2 py-2 hover:font-azeri">Wix Templates</a>
                  <a href="/template" className="block px-2 py-2 hover:font-azeri">WordPress Templates</a>
                </div>
              )} */}
            </div>


            {/* Resources Dropdown */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('resources')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <a href='/about' className="cursor-default inline-block hover:text-[#c6884a]">About</a>
              {/* {openDropdown === 'resources' && (
                <div className="absolute bg-white shadow-lg mt-0 py-2 z-50 w-48">
                  <a href="/blog" className="block px-2 py-2 hover:font-azeri">Blog</a>
                </div>
              )} */}
            </div>



          </div>

          {/* Contact Button */}
          <a
            className="rounded-full bg-[#CFF098] px-12 py-2 text-black border-[1px] border-black uppercase hover:opacity-60"
            href="/contact"
          >
            Inquire
          </a>
        </div>


        

        {/* Hamburger Menu on Right for Mobile */}
        <button
          className="absolute right-6 top-6 md:hidden text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={30} /> : <Menu size={30} />}
        </button>

        {/* Mobile Menu */}
        <div
          className={`${
            isOpen ? 'flex' : 'hidden'
          } flex-col items-center space-y-6 md:hidden font-bold text-white bg-black p-5`}
        >
          <a href="/" className="uppercase hover:underline">Home</a>
          <a href="/services" className="uppercase hover:underline">About Us</a>
          <a
            className="rounded-full bg-[#CFF098] hover:underline px-12 py-2 text-black border-[1px] border-black uppercase hover:opacity-60"
            href="/contact"
          >
            Contact
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
